import { Controller } from '@hotwired/stimulus';
import loadDefaultDatatable from '../../views/route_sections/datatable';
import filterLoader from '../../views/route_sections/filter';

// Connects to data-controller="pages--route-section"
export default class extends Controller {
  connect() {
    loadDefaultDatatable();
    filterLoader();
  }
}
